import { formatLimit } from './sessionCap';

// Сервер bit-streaming не шлёт {type:'error'} на протокольные проблемы — только
// закрывает WS с кодом/причиной (см. bit-streaming/app/main.py). Переводим в текст
// для пользователя; null — штатное закрытие, показывать нечего.
export function describeClose(code, reason = '', limitSec = null) {
  const r = reason || '';
  if (code === 1008) {
    if (r === 'quota_exhausted') return 'Исчерпана квота на распознавание.';
    if (r === 'pace_exceeded') return 'Превышен темп передачи аудио.';
    if (r === 'frame_too_large' || r === 'bad_message') return 'Ошибка протокола потоковой передачи.';
    return 'Ошибка авторизации. Войдите в систему и попробуйте снова.';
  }
  if (code === 1011) return 'Ошибка сервиса распознавания.';
  if (code === 1013) return 'Сервер занят, попробуйте позже.';
  if (code === 1001) return 'Сервис перезапускается, попробуйте позже.';
  // Обрыв без закрывающего кадра. В записи он ведёт к переподключению, а сюда
  // попадает, только когда переподключаться не из чего (сеанс так и не начался).
  if (code === 1006) return 'Связь с сервером прервалась. Распознанный текст сохранён.';
  if (code === 1000 && r.includes('idle')) return 'Сессия завершена из-за неактивности.';
  if (code === 1000 && r === 'max_session') {
    // Сам предел называет сервер (кадр status → sessionCap.formatLimit): своя
    // копия числа тут врала бы ровно с той правки конфига, о которой не узнали.
    const limit = formatLimit(limitSec);
    return `Достигнут лимит длительности одной записи${limit ? ` (${limit})` : ''}.`
      + ' Распознанный текст сохранён — можно начать новую запись.';
  }
  return null;
}

// Переподключение не удалось за отведённое время или буфер звука полон
// (resilientSession: MAX_OFFLINE_SEC / MAX_BUFFER_SEC). Молча — никогда.
export const RECONNECT_GAVE_UP_MESSAGE =
  'Связь не восстановилась за 5 минут. Распознанный до обрыва текст сохранён.';

// Первое подключение оборвалось, не начавшись: текста ещё нет, «сохранён» было бы враньём.
export const CONNECT_FAILED_MESSAGE =
  'Не удалось подключиться к сервису распознавания. Проверьте связь и попробуйте снова.';

// Буфер переполнился на живом сеансе: связь есть, но сервер не успевает.
export const BACKLOG_OVERFLOW_MESSAGE =
  'Не успеваем догнать распознавание — запись остановлена, распознанный текст сохранён.';

/** «ещё 40 с» / «ещё 3 мин» — сколько осталось догнать или дописать. */
export function formatWait(sec) {
  const s = Math.max(1, Math.ceil(sec));
  return s < 60 ? `${s} с` : `${Math.ceil(s / 60)} мин`;
}
